module.exports = "<nz-page-header (nzBack)=\"onBack()\" nzBackIcon nzTitle=\"Title\"> </nz-page-header>\n"